<app-basic-page [pageTitle]="'Product'" [pageDescription]="'The product used for practice.'">
  <button class="header-right" nz-button nzType="primary" nzSize="default" (click)="onNewBtnClick()">
    <span nz-icon style="font-size: 16px" class="material-symbols-rounded">add</span>
    Add Product
  </button>

  <nz-table class="full-width" #productTable [nzData]="itemList()" [nzPaginationType]="'small'" [nzPageSize]="8">
    <thead>
      <tr>
        <th [nzWidth]="'250px'">Title</th>
        <th>Description</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      @for (data of productTable.data; track data.id; let i = $index) {
        <tr>
          <td>{{ data.title }}</td>
          <td>{{ data.description | truncate: 100 }}</td>
          <td>
            <div class="horizontal">
              <button nz-button nzType="text" [matTooltip]="'Edit'" (click)="onEditClick(data)">
                <span nz-icon style="font-size: 16px" class="material-symbols-rounded">edit</span>
              </button>
              <button
                nz-button
                nzType="text"
                [matTooltip]="'Remove'"
                [nzDanger]="true"
                nz-popconfirm
                nzOkText="Remove"
                nzPopconfirmTitle="Are you sure you want to remove this product?"
                nzPopconfirmPlacement="bottom"
                (nzOnConfirm)="onDeleteClick(i)"
              >
                <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete_forever</span>
              </button>
            </div>
          </td>
        </tr>
      }
    </tbody>
  </nz-table>
</app-basic-page>

<app-new-edit-product
  [selectedItem]="selectedItem()"
  [(isNewEditVisible)]="isNewEditVisible"
  [isEdit]="isEdit"
></app-new-edit-product>
